module.exports = __webpack_public_path__ + "./assets/fonts/OpenSans-SemiBoldItalic.ttf?4f04fe541ca8be9b60b500e911b75fb5";